import { DateField, DatePicker, Divider, Form, Modal, TextField, Upload } from '@ui';
import React from 'react';
import { IMedicalRecordForm, initialValues, validationSchema } from './medical-record-form.schema';
import { FormSC } from './medical-record-form.styled';
import { addMedicalRecord } from '@services/external/medicalRecords.api';

interface MedicalRecordFormProps {
  visible: boolean;
  onClose: () => void;
  afterSubmit?: () => void;
  clientId: string;
  providerId: string;
}

const MedicalRecordForm: React.FunctionComponent<MedicalRecordFormProps> = ({
  visible,
  onClose,
  afterSubmit,
  clientId,
  providerId,
}) => {
  const [submitting, setSubmitting] = React.useState(false);

  const onSubmit = React.useCallback(
    async (values: IMedicalRecordForm) => {
      setSubmitting(true);
      try {
        const formData = new FormData();

        formData.append('name', values.name);
        formData.append('dateOfMedicalRecord', values.dateOfMedicalRecord[0].toISOString());
        formData.append('medicalRecordFile', values.medicalRecordFile![0].originFileObj!);

        await addMedicalRecord(providerId, clientId, formData);
        afterSubmit?.();
        onClose();
      } catch (error) {
      } finally {
        setSubmitting(false);
      }
    },
    [afterSubmit, clientId, onClose, providerId],
  );

  const [form, formOptions] = Form.useForm({ initialValues, onSubmit, validationSchema });

  React.useLayoutEffect(() => {
    form?.resetForm?.();
  }, [visible]);

  return (
    <Modal
      onClose={onClose}
      destroyOnClose
      visible={visible}
      title="Nový záznam"
      closable
      footer={
        <Modal.Actions
          actions={[
            { key: 'cancel', label: 'Zrušiť', variant: 'ghost', onClick: onClose },
            {
              key: 'submit',
              label: 'Uložiť',
              variant: 'primary',
              onClick: () => {
                form?.submitForm?.();
              },
              loading: submitting,
            },
          ]}
        />
      }
    >
      <FormSC {...formOptions}>
        <Form.Field
          name={'medicalRecordFile'}
          label="Záznam"
          getValueFromEvent={Upload.getValueFromEvent}
          valuePropName={Upload.valuePropName}
          showFeedback={false}
          showLabel={false}
        >
          <Upload.Dragger
            accept="image/jpeg,image/png,application/pdf"
            beforeUpload={() => false}
            showFileList
            maxCount={1}
            multiple={false}
            style={{ width: '100%' }}
          >
            <Upload.Dragger.Button style={{ width: '100%' }} description={'.jpeg, .png, .pdf'} />
          </Upload.Dragger>
        </Form.Field>
        <Divider style={{ margin: '16px 0' }} />
        <Form.Field name="name" label="Názov záznamu" required>
          <TextField />
        </Form.Field>
        <Form.Field
          name="dateOfMedicalRecord"
          label="Dátum vytvorenia záznamu"
          required
          getValueFromEvent={(e) => e}
        >
          <DatePicker mode="date" />
        </Form.Field>
      </FormSC>
    </Modal>
  );
};

export default MedicalRecordForm;
